/** ฝ่ามือสุขาวดี (lane C4 skeleton): violet + blossom, motif drops. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const BLISSPALM_FX: ReturnType<typeof makeHandArt> = makeHandArt('quiet-palm', { a: 'violet', b: 'blossom', motif: 'drops' }, [
  ['jl-claw', 'claw'],
  ['jl-needle', 'throw', 6],
  ['jl-charm', 'claw'],
  ['jl-step', 'buff'],
  ['jl-soul', 'grab'],
  ['jl-drain', 'claw'],
  ['jl-bloom', 'throw', 6],
  ['jl-abyss', 'power', 2],
]);
